import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import Marquee from "react-fast-marquee";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; // Recommend Redux dispatch integration

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [userprofilename, setuserprofilename] = useState(""); 
  const [logbtn, setlogbtn] = useState("Login");
  const [checkadmin, setCheckadmin] = useState("user");

  const navigate = useNavigate();
  // If you have a logout action in Redux, import and use dispatch
  // const dispatch = useDispatch();

  const { token } = useSelector((state) => state.auth);
  const profileRef = useRef(null);
  const notificationRef = useRef(null);

  // System Notifications
  const systemAlerts = [
    { id: 1, text: "📦 Low inventory warning (SKU-204)", time: "5m ago" },
    { id: 2, text: "💸 New premium transaction verified", time: "42m ago" },
  ];

  const logcheck = () => {
    if (!token) {
      // Trigger login modal via custom event
      window.dispatchEvent(
        new CustomEvent("TRIGGER_AUTH_MODAL", { detail: { mode: "login" } })
      );
      return;
    } else {
      // 1. Clear complete localStorage traces
      localStorage.removeItem("token");
      localStorage.removeItem("access_token");
      localStorage.removeItem("admin_token");
      localStorage.removeItem("user_profile");

      // 2. Clear state cleanups
      setlogbtn("Login");
      setuserprofilename("");
      setCheckadmin("user"); // 🎯 FIX: Admin role reset on logout
      setIsProfileDropdownOpen(false);

      // 3. Dispatch Redux logout if available
      // dispatch(logoutAction());

      // 4. Redirect safely
      navigate("/");
      window.location.reload(); 
    }
  };

  // Sync UI view directly when Redux token authentication status updates
  useEffect(() => {
    if (!token) {
      setlogbtn("Login");
      setuserprofilename("");
      setCheckadmin("user"); // 🎯 FIX: Reset admin status when token is missing
    } else {
      setlogbtn("Logout");
      
      const admintoken = localStorage.getItem("admin_token");
      if (admintoken) {
        setCheckadmin("admin");
      } else {
        setCheckadmin("user");
      }

      const userProfile = localStorage.getItem("user_profile");
      if (userProfile) {
        try {
          const parsedData = JSON.parse(userProfile);
          if (parsedData && parsedData.name) {
            setuserprofilename(parsedData.name);
          }
        } catch (e) {
          console.error("Error parsing user profile from localStorage:", e);
        }
      }
    }
  }, [token]);

  // Close dropdowns automatically on clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsProfileDropdownOpen(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setIsNotificationsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="header">
      <div className="header-top">
        <div className="header-top-left">
          <ul>
            <li>
              <Link to="/myorder">
                <small>Order Tracking</small>{" "}
              </Link>{" "}
              |
            </li>
            <li>
              <small>
                Save up to 10% on all products with "GET10OFF" code
              </small>{" "}
            </li>
          </ul>
        </div>

        <div className="header-top-right">
          <div className="header-top-right-contact">
            <small>
              Need help? Call Us: <a href="#call">You can request a call back</a>
            </small>
          </div>
        </div>
      </div>

      <nav className="core-navbar">
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <button
            className={`hamburger-toggle-btn ${
              isMobileMenuOpen ? "toggle-open" : ""
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation"
          >
            <span className="burger-bar"></span>
            <span className="burger-bar"></span>
            <span className="burger-bar"></span>
          </button>
          <Link to="/">
            <div className="nav-logo">
              RBUY<span>MART</span>
            </div>
          </Link>
        </div>

        {/* DESKTOP VIEW NAV-LINKS CLUSTER */}
        <div
          className={`nav-links-cluster ${
            isMobileMenuOpen ? "mobile-active" : ""
          }`}
        >
          <Link to="/about" className="nav-link">
            About
          </Link>
          <Link to="/shop" className="nav-link">
            Shop
          </Link>
          <Link to="/blog" className="nav-link">
            Blog
          </Link>
          <div className="search-input">
            <i className="material-icons" style={{ color: "black" }}>
              &#xe8b6;
            </i>
            <input
              type="search"
              placeholder="Search any products..."
              className="search-input-field"
            />
            <button className="search-btn">Search</button>
          </div>
        </div>

        {/* SYSTEM UTILITIES ACTION CONTROLS */}
        <div className="nav-actions-node">
          <Link to="/cart" className="action-icon-btn">
            <i className="material-icons">&#xe8cc;</i>
          </Link>

          <div className="action-wrapper" ref={notificationRef}>
            <button
              className="action-icon-btn"
              onClick={() => setIsNotificationsOpen(!isNotificationsOpen)}
            >
              <i className="material-icons">&#xe7f4;</i>
              {systemAlerts.length > 0 && (
                <span className="alert-badge">{systemAlerts.length}</span>
              )}
            </button>

            {isNotificationsOpen && (
              <div className="nav-dropdown shadow-matrix animate-fade-in">
                <div className="dropdown-header">SYSTEM ALERTS</div>
                {systemAlerts.map((alert) => (
                  <div key={alert.id} className="dropdown-item alert-item">
                    <p>{alert.text}</p>
                    <span>{alert.time}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="header-top-right-auth">
            {/* Profile Admin Portal Settings */}
            <div className="action-wrapper" ref={profileRef}>
              <button
                className="action-profile-btn"
                onClick={() =>
                  setIsProfileDropdownOpen(!isProfileDropdownOpen)
                }
              >
               <i class="material-icons">&#xe853;</i>
                {userprofilename || "Login"}
                <span className="arrow-down">
                  <i className="material-icons">&#xe313;</i>
                </span>
              </button>

              {isProfileDropdownOpen && (
                <div className="nav-dropdown dropdown-profile-width shadow-matrix animate-fade-in">
                  <Link to="/settings" className="dropdown-item">
                    <i className="material-icons">&#xe8b8;</i> Settings
                  </Link>
                  <Link to="/profile" className="dropdown-item">
                    <i className="material-icons">&#xe55a;</i> Account Profile
                  </Link>
                  <Link to="/myorder" className="dropdown-item">
                    <i className="material-icons">&#xe8cb;</i> My Orders
                  </Link>

                  {checkadmin === "admin" && (
                    <Link to="/admin/dashboard" className="dropdown-item">
                      <i className="material-icons">&#xe853;</i> Admin
                    </Link>
                  )}

                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item logout-trigger"
                    onClick={logcheck}
                  >
                    <i className="material-icons">&#xe879;</i> {logbtn}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
           <Marquee pauseOnHover={true}>
              <div className="announcement-track">
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Free, Fast, &amp;Delivery
                </span>
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> India's No. 1 Brand
                </span>
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> COD Available
                </span>
                  <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Secure payment
                </span>
                  <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Premium Quality
                </span>
                  <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Privacy Protected
                </span>
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Cash on delivery
                </span>
                      <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Free, Fast, &amp;Delivery
                </span>
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> India's No. 1 Brand
                </span>
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> COD Available
                </span>
                  <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Secure payment
                </span>
                  <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Premium Quality
                </span>
                  <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Privacy Protected
                </span>
                <span className="ann-item">
                  <i className="material-icons">&#xe558;</i> Cash on delivery
                </span>
              </div>
            </Marquee>
    </header>
  );
};

export default Navbar;